import { IonIcon } from "@ionic/react";
import { person, people } from "ionicons/icons";

const SingleMultiPlayer = ({ isSinglePlayer = true, className = "" }) => {
  return (
    <div
      className={`flex items-center mx-auto bg-primary-80 rounded-lg px-4 py-1.5 gap-2 ${className}`}
    >
      <IonIcon
        icon={isSinglePlayer ? person : people}
        className="text-white text-sm"
      />
      <p className="text-white">
        {isSinglePlayer ? "Single Player" : "Multiplayer"}
      </p>
    </div>
  );
};

export default SingleMultiPlayer;
